module.exports = __webpack_public_path__ + "media/images/athletes/1698-a304ae9e97d9657a981158f18d95cc10.png";